/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleDown: {
  name: 'triangle-down';
  data: string;
} = {
  name: 'triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 6H4l4 4 4-4Z" fill="currentColor"/></svg>`,
};
